<!-- eslint-disable -->
<template lang="pug">
    table.playground
        tr(v-for="(elements, rowIndex) in allItems")
            td.search-item(v-for="(item, columnIndex) in elements")
                img(:src="item.value | apiFile" @click="$emit('selectItem', item, rowIndex, columnIndex)")
</template>

<script>
    /*eslint-disable*/
    const HUGE_MATRIX = 4;

    export default {
        props: {
            allItems: Array,
        },
        mounted () {
            let windowWidth = window.innerWidth;
            if (this.allItems.length === 3 && windowWidth > 1200) {
                let searchItems = Array.from(document.querySelectorAll('.search-item'));
                searchItems.forEach(item => {
                    item.firstChild.style.maxHeight = windowWidth < 1440 ? '120px' : '200px';
                })
            }
            if (this.allItems.length >= HUGE_MATRIX) {
                let tableContainer = document.querySelector('.table-container');
                if (windowWidth > 1200 && windowWidth < 1700) {
                    tableContainer.style.width = '40%';
                }
                if (windowWidth > 1699 && windowWidth) {
                    tableContainer.style.width = '45%';
                }
                if (this.allItems.length === 6 && windowWidth < 1440) {
                    tableContainer.firstChild.style.borderSpacing = '0';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .playground {
        width: auto;
        border-collapse: separate;
        border-radius: 12px;
        border-spacing: 5px;
    }

    .search-item {
        padding: 0 5px;
        cursor: pointer;
        user-select: none;
        img {
            border-radius: 8px;
            border: 3px solid $hsl-color-gray-92;
            max-height: 210px;
            @include media ($lg) {
                max-height: 190px;
            }
            @include media ($xl) {
                max-height: 290px;
            }
            @include media ($xxl) {
                max-height: 350px;
            }
        }
    }

    .search-item_selected img {
        border: 3px solid $hsl-color-green-58;
    }

    .search-item_correct img {
        pointer-events: none;
        border: 3px solid $hsl-color-green-58;
    }

    .search-item_before-game-start img {
        border: none;
    }

    td:empty {
        visibility: hidden;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
